import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeTone =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'neutral'
  | 'navy'
  | 'orange';

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md';
}

const toneStyles: Record<BadgeTone, string> = {
  success: 'bg-success-bg text-success-dark',
  warning: 'bg-warning-bg text-warning-dark',
  danger: 'bg-danger-bg text-danger-dark',
  info: 'bg-info-bg text-info-dark',
  neutral: 'bg-surface-muted text-ink-secondary',
  navy: 'bg-brand-navy text-white',
  orange: 'bg-brand-orange text-white',
};

const sizeStyles = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-0.5 text-xs',
};

export function Badge({ tone = 'neutral', size = 'md', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 font-semibold rounded-full whitespace-nowrap',
        toneStyles[tone],
        sizeStyles[size],
        className,
      )}
    >
      {children}
    </span>
  );
}
